import React from "react";
import * as S from "./style";
import Title from "../Typography/Title";

type ConsulenzaProps = {
  description?: string;
  book?: string;
  title: string;
  mailto?: string;
};

const Consulenza: React.FC<ConsulenzaProps> = ({
  description,
  book,
  title,
  mailto,
}) => {
  return (
    <>
      <S.Container>
        <S.SubContainer>
          <S.Title>{title}</S.Title>
          <p>{description}</p>
        </S.SubContainer>
        <S.SubContainer>
          <S.Link href={mailto}>{book}</S.Link>
        </S.SubContainer>
      </S.Container>
    </>
  );
};

export default Consulenza;
